module.exports = __webpack_public_path__ + "img/ekszerteknos80.aa120b70.jpg";